import React from "react";
import "../App.css";
import Fire from "../config/Fire";
//import {InfiniteLoading} from 'react-simple-infinite-loading'
import InfiniteScroll from 'react-infinite-scroll-component';
import RenderPost from "../utils/Post/RenderPost";
import {Link } from 'react-router-dom'
import Aux from "../utils/AuxFunctions";
import { withMyDataContext } from "../context/DataProvider";
import Loader from "../utils/Utilities/Loader"
import Colors from "../utils/Colors";

const LIMIT = 10;
const DEFAULT_TYPE = "latest"

class ShowData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postsData: [],
            lastVisible: null,
            finished: false,
            loading: false,
            hashtag: "",
            type: "latest",
            activeLink: this.props.type || "latest",
            currentHashtag: "",
            currentType:"",
        }
    }

    componentDidMount() {
        try {
            if (this.props.match.params.tag) {
                this.props.myDataProvider.setNewHashtag(this.props.match.params.tag)
                
                if(this.props.match.params.type){
                    this.setState({ hashtag: this.props.match.params.tag, type: this.props.match.params.type.toLowerCase() || DEFAULT_TYPE })
                    this.getAllData(true, this.props.match.params.type || DEFAULT_TYPE, null, this.props.match.params.tag);
                }else{
                    this.getAllData(true, DEFAULT_TYPE, null, this.props.match.params.tag);
                    this.setState({ hashtag: this.props.match.params.tag,})
                }
                
            } else if (this.props.match.params.type) {
                this.setState({ type: this.props.match.params.type.toLowerCase() || DEFAULT_TYPE, hashtag: "" })
                this.getAllData(true, this.props.match.params.type.toLowerCase());
            } else if (this.props.match.params.link) {
                this.getAllData(true, "link", this.props.match.params.id);
            } else if (this.props.type) {
                this.setState({ type: this.props.type.toLowerCase() || DEFAULT_TYPE })
                this.getAllData(true, this.props.type);
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentDidUpdate(prevProps, prevState) {

        const { match: { params: { tag, type } } } = this.props

        if (prevProps.match.params.tag !== tag) {
            this.props.myDataProvider.setNewHashtag(tag)
            this.setState({ hashtag: tag, type: DEFAULT_TYPE })
            this.getAllData(true, type ? type : DEFAULT_TYPE, null, tag);

        } else if (prevProps.match.params.type !== type && type !== this.state.type) {
            this.setState({ type: type })
            this.getAllData(true, type || DEFAULT_TYPE, null, tag ? tag: "");
        } else if (prevProps.type !== this.props.type) {

            this.setState({ type: this.props.type })
            this.getAllData(true, this.props.type || DEFAULT_TYPE);
        }
    }

    getAllData = async (isStart, type, id, cat) => {
        if (this.state.loading) return;
        let lastVisible = null;
        let currentType = type;
        let currentHashtag = cat;
        if (isStart) {
            this.setState({
                postsData: [],
                finished: false,
                lastVisible: null,
                hashtag: ""
            });
        } else {
            lastVisible = this.state.lastVisible
            currentType = this.state.currentType
            currentHashtag = this.state.currentHashtag
        }

        try {

            this.setState({ loading: true, currentHashtag: cat, currentType: type })
            Fire.shared
                .GetPostsData(currentType || DEFAULT_TYPE, lastVisible, LIMIT, id, currentHashtag)
                .then(snapshot => {
                    if (snapshot) {
                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({ finished: true })
                        }

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });
                        this.setState({
                            postsData: [...this.state.postsData, ...data],
                            lastVisible: snapshot.docs[snapshot.docs.length - 1],
                            loading: false,
                        });

                    } else {
                        this.setState({ finished: true, loading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error)
        }
    };

    getPathname = (type) => {
        if (this.props.match.params.tag) {
            return "/hashtag/" + this.props.match.params.tag + "/" + type
        } else {
            return "/" + type
        }
    }

    render() {

        return (
            // <div className="content-home" style={{backgroundColor:"#ECEFF1", display:"flex", justifyContent:"center", height:"100%", width:"100%"}}>
            <div id="scrollable" style={{ justifyContent: "center", width: "100%" }}>
                {/* <SideBarContent menuItems={menuItems} styles={styles} /> */}
                <div style={{ display:"flex", margin: "0 10px", marginTop:20 }} className="show-data-title-bar" >
                    <div style={{
                        display: "inline-flex", justifyContent: "flex-start", /*backgroundColor:"white", WebkitBoxShadow:"0px 1px 2px 0px rgba(0,0,0,.15)", */
                        MozBoxShadow: "0px 1px 2px 0px rgba(0,0,0,.15)"
                        }}>
                        <Link style={{textDecoration: "none", marginRight: 20, 
                            padding:"5px 15px", borderColor: "#ccc", borderRadius:5, borderStyle:"solid", borderWidth:1,  }}
                            to={{ pathname: this.getPathname("latest") }} className="text-hover">
                            <h3 style={{ color: this.state.type === "latest" ? Colors.mainColor : "grey" }}>Latest</h3>
                        </Link>
                        <Link replace style={{ color: "grey", textDecoration: "none", marginRight: 20,
                            padding:"5px 15px", borderColor: "#ccc", borderRadius:5, borderStyle:"solid", borderWidth:1,  }}
                            to={this.getPathname("top")} className="text-hover">
                            <h3 style={{ color: this.state.type === "top" ? Colors.mainColor : "grey" }}>Top</h3>
                        </Link>
                        
                        <Link style={{ color: "grey", textDecoration: "none", marginRight: 20,
                            padding:"5px 15px", borderColor: "#ccc", borderRadius:5, borderStyle:"solid", borderWidth:1,  }}
                            to={{ pathname: this.getPathname("trending") }} className="text-hover">
                            <h3 style={{ color: this.state.type === "trending" ? Colors.mainColor : "grey" }}>Trending</h3>
                        </Link>
                    </div>
                </div>
                <InfiniteScroll
                    //style={{backgroundColor:"#ECEFF1", minHeight:"86vh"}}
                    dataLength={this.state.postsData.length}
                    next={this.getAllData}
                    scrollableTarget="sideBar"
                    hasMore={!this.state.finished}
                    initialScrollY={0}
                    loader={<div style={{marginTop:20}}><Loader color={"#999"}></Loader></div>}
                    endMessage={
                        <div style={{marginTop:20}}>
                            {this.state.postsData.length === 0 ?
                            <p style={{ textAlign: 'center' }}>
                                <b>there are no posts yet.</b>
                            </p>
                            :
                            <p style={{ textAlign: 'center' }}>
                                <b>You have seen it all.</b>
                            </p>}
                        </div>
                    }
                >
                    {this.state.postsData.map((item, index) => (
                        <RenderPost post={item} key={item.id + index} styles={this.props.styles}></RenderPost>
                    ))}
                </InfiniteScroll>
            </div>
        );
    }
}

export default withMyDataContext(ShowData);
